import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

const CustomWatermarkCard = styled(Card)(({ watermarkText = "" }) => ({
  position: 'relative',
  overflow: 'hidden',

  // Insert the keyframes
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
  },

  '&::before': {
    content: `"${watermarkText}"`,
    position: 'absolute',
    bottom: 0,
    left: "50%",
    transform: 'translateX(-50%)',
    fontSize: 'clamp(16px, 4vw, 24px)',
    fontWeight: 'bold',
    color: 'rgba(121, 121, 121, 0.8)',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    zIndex: 0,
    width: 'max-content', // Allow text to maintain its natural width
    // animation: 'slide 20s linear infinite', // Adjust duration as needed
    // willChange: 'transform', // Optimize animation performance
  },

  // Add keyframes to component
  '@keyframes slide': {
    from: {
      transform: 'translateX(100%)',
    },
    to: {
      transform: 'translateX(-100%)',
    },
  },
  '> *': {
    position: 'relative',
    zIndex: 1,
  },
}));

export default CustomWatermarkCard;